import ContentExtra from "./ContentExtra.jsx"

export default ContentExtra;